import { useEffect, useState } from 'react'

export const useTimeState = <T>(callback: () => T, time: number, disabled?: boolean) => {
    const [state, setState] = useState<T>(callback())

    useEffect(() => {
        if (disabled) return

        let interval: NodeJS.Timer

        const timeoutSec = 60 - new Date().getSeconds()

        const timeout = setTimeout(() => {
            setState(callback())

            interval = setInterval(() => {
                setState(callback())
            }, time)
        }, timeoutSec * 1000)

        return () => {
            clearTimeout(timeout)
            clearInterval(interval)
        }
    }, [time, callback, disabled])

    return state
}
